// Org-level gate for the Employee Activity page.
//
// Employee Activity is enabled per-org via the main-admin panel toggle
// (org.employeeActivityEnabled in DB, surfaced on billing/profile). Until a main_admin
// flips it on, no one in that org sees the page. When on, only ORG ADMINS see it.
//
// Mirrors modules/crm/utils/orgGating.js exactly (same shape, same fallback to
// window.__orgProfile set by Layout after the billing/profile fetch).

/**
 * Is the Employee Activity page enabled at all for this org?
 * Pass the org object from billing/profile (has employeeActivityEnabled).
 * Falls back to window.__orgProfile if org is null/undefined.
 */
export function isEmployeeActivityEnabledForOrg(org) {
  const resolved = (org && typeof org === 'object')
    ? org
    : (typeof window !== 'undefined' ? window.__orgProfile : null);
  if (!resolved) return false;
  return resolved.employeeActivityEnabled === true;
}

/**
 * Should this user see Employee Activity (sidebar item + page access)?
 * - Org must have employeeActivityEnabled === true
 * - User must be an org admin (org_admin / main_admin)
 *
 * @param {object} user - TG user object from AuthContext
 * @param {object} org  - org object from billing/profile; falls back to window.__orgProfile
 */
export function canUserAccessEmployeeActivity(user, org) {
  if (!user) return false;
  if (!isEmployeeActivityEnabledForOrg(org)) return false;
  return user.role === 'org_admin' || user.role === 'main_admin';
}
